import React from 'react'
import Span from 'components/Span'
import getPriceLabelStringUtil from 'utils/string/get-price-label'
import getPriceOrFreeLabelStringUtil from 'utils/string/get-price-or-free-label'
import shouldShowStrikethroughProductCardUtil from 'components/ProductCard/utils/should-show-strike-through/index.js'

export default function ProductCardPrice (props) {
  const {
    price,
    hasDiscount,
    discountPrice,
    priceMin,
    priceMax,
    compareAtPrice,
    rawPrice
  } = props

  const showStrikethrough = shouldShowStrikethroughProductCardUtil({ rawPrice, compareAtPrice })

  const hasMinMaxPrice = priceMin && priceMax
  let element

  if (showStrikethrough) {
    element = (
      <>
        <s>{getPriceOrFreeLabelStringUtil(compareAtPrice)}</s>
        <Span><b>{getPriceOrFreeLabelStringUtil(rawPrice)}</b></Span>
      </>
    )
  } else if (hasMinMaxPrice) {
    const minLabel = getPriceLabelStringUtil(priceMin, { ignoreZeroDecimals: true })
    const maxLabel = getPriceLabelStringUtil(priceMax, { ignoreZeroDecimals: true })
    element = (
      <Span><b>{minLabel}-{maxLabel}</b></Span>
    )
  } else if (hasDiscount) {
    element = (
      <>
        <s>{getPriceOrFreeLabelStringUtil(price)}</s>
        <Span><b>{getPriceOrFreeLabelStringUtil(discountPrice)}</b></Span>
      </>
    )
  } else {
    element = <Span><b>{getPriceOrFreeLabelStringUtil(price)}</b></Span>
  }

  return (
    <>
      <p className='product-price'>
        {element}
      </p>
    </>
  )
}
